<template>
  <modal name="requisite" height="auto" :scrollable="true">
    <div class="modal-form" >
      <div class="header">
        <div class="title">{{ name }}</div>
        <img class="hover_btn" src="../../assets/icons/close.svg" @click="close()"  alt="">
      </div>
      <div class="top__title-radio">

        <div
            class="top__title-radio-item"
            v-for="(item) in state"
            :class="{active: active == item.key}"
            :key="item.key"
            @click="active = item.key"
        >
          {{item.title}}
        </div>
      </div>
      <h4>Название счета*</h4>
      <div class="input-block">
        <input type="text"
               v-model="name"
               name="name"
               value="Основной"
               @blur="blurName"
               autocomplete="off"
               v-validate="'required'"
               data-vv-validate-on="blur"
               data-vv-as="Название счета"
        >
        <small>Вы можете изменить название счета</small>
        <span class="text-danger text-sm">{{ errors.first('name') }}</span>
        <span class="text-danger text-sm" v-if="isset_name">{{ isset_name}}</span>
      </div>
      <h4>Расчетный счет*</h4>
      <div class="input-block">
        <input
            type="text"
            autocomplete="off"
            v-model="checking_account"
            name="checking_account"
            v-validate="'required|min:20|max:20|integer'"
            data-vv-validate-on="blur"
            data-vv-as="Расчетный счет"
        >
        <span class="text-danger text-sm" >{{ errors.first('checking_account') }}</span>
      </div>
      <h4>Корреспондентский счет*</h4>
      <div class="input-block">
        <input
            type="text"
            autocomplete="off"
            v-model="correspondent_account"
            name="correspondent_account"
            v-validate="'required|min:20|max:20|integer'"
            data-vv-validate-on="blur"
            data-vv-as="Корреспондентский счет"
        >
        <span class="text-danger text-sm" >{{ errors.first('correspondent_account') }}</span>
      </div>
      <h4>БИК*</h4>
      <div class="input-block">
        <input
            type="text"
            autocomplete="off"
            v-model="bik"
            @keyup="changeBik()"
            name="bik"
            v-validate="'required|min:9|max:9|integer'"
            data-vv-validate-on="blur"
            data-vv-as="БИК"
        >
        <span class="text-danger text-sm" >{{ errors.first('bik') }}</span>
      </div>
      <h4>Название банка*</h4>
      <div class="input-block">
        <input
            type="text"
            autocomplete="off"
            v-model="bank"
            name="bank"
            v-validate="'required'"
            data-vv-validate-on="blur"
            data-vv-as="Банк"
        >
        <span class="text-danger text-sm" >{{ errors.first('bank') }}</span>
      </div>
      <h4>Адрес банка*</h4>
      <div class="input-block">
        <input
            type="text"
            autocomplete="off"
            v-model="bank_address"
            name="bank_address"
            v-validate="'required'"
            data-vv-validate-on="blur"
            data-vv-as="Адрес банка"
        >
        <span class="text-danger text-sm" >{{ errors.first('bank_address') }}</span>
      </div>
      <app-checkbox v-if="!active" :value="main" @input="changeMain($event)" >Основной счет</app-checkbox>
      <span class="text-danger text-sm" v-if="isset_main">{{ isset_main}}</span>
      <div class="btn">
        <button @click="addRR()" :disabled="errors.any()">Сохранить</button>
      </div>
    </div>
  </modal>
</template>

<script>
import AppCheckbox from "@/components/app-checkbox";
export default {
  name: "add-rr-modal",
  components: { AppCheckbox },
  data: () => ({
    name: 'Основной',
    state: [
      { title: 'Активный', key: 0 },
      { title: 'Неактивный', key:1 },
    ],
    checking_account: '',
    correspondent_account: '',
    bik: '',
    bank: '',
    bank_address: '',
    requisite_name_error: '',
    checking_account_error: '',
    correspondent_account_error: '',
    bik_error: '',
    bank_error: '',
    active: 0,
    main: false,
    edit: false,
    success: true,
    key: null,
    requisites: null,
    isset_name: null,
    isset_main: null,
    id: ''
  }),
  methods: {
    openRRModal (edit, key, requisites) {
      console.log (edit)
      if(edit != undefined){
        if(key == undefined) return this.$toast.error('Поле key Не указано')
        this.edit = true;
        this.key = key;
        this.name = edit.name;
        this.id = edit.id;
        this.checking_account = edit.checking_account;
        this.correspondent_account = edit.correspondent_account;
        this.bik = edit.bik;
        this.bank = edit.bank;
        this.bank_address = edit.bank_address;
        this.main = edit.main;
        this.active = edit.active;
      }else {
        this.requisite_name = this.checking_account = this.correspondent_account = this.bik = this.bank = this.bank_address = this.id = null;
        this.edit = this.main = false;
      }
      if (requisites != undefined){
        this.requisites = requisites;
        if (requisites.length < 1) {
          this.main = true;
        }
      }

      this.$modal.show('requisite');
    },
    changeMain($event){
          this.isset_main = null;
          if (this.requisites) {
            if (this.requisites.length) {
              if ($event == true) {
                let flag = false;
                this.requisites.map(function (el) {
                  if (el.main == true && !flag) {
                    flag = true;
                    this.isset_main = 'У вас уже выбран основной счет. Для того, чтобы выбрать этот счет основным, снимите галочку с текущего основного счета';
                    return;
                  }
                  if (el.main == false) {
                    this.main = $event
                  }
                }, this, flag)
              } else {
                this.main = $event
              }
            } else {
              this.main = $event
            }
          }else {
            this.main = $event
          }
    },
    blurName(){
      if (this.requisites.length){
        this.isset_name = null;
        this.requisites.map(function (el){
          if (el.name == this.name){
            this.isset_name = 'Название счета уже существует';
          }
        },this)
      }
    },
    clear(){
      this.main = this.edit = false;
      this.key = null;
      this.name = this.id = this.checking_account = this.correspondent_account = this.bik = this.bank = this.bank_address = '';
    },
    close(){
      this.$modal.hide('requisite')
      this.clear()
    },
    addRR() {
      if(!this.isset_name && !this.isset_main) {
        this.$validator.validateAll().then(success => {
          this.success = success;
          if (success) {
            this.$emit('save', {
              key: this.key,
              data: {
                name: this.name,
                checking_account: this.checking_account,
                correspondent_account: this.correspondent_account,
                bik: this.bik,
                bank: this.bank,
                bank_address: this.bank_address,
                main: this.main,
                active: this.active,
                id: this.id
              }
            })
            this.$modal.hide('requisite');
            this.clear()
          }
        })
      }
    },
    changeBik(){
      if(!this.bank && !this.bank_address) {
        if (this.bik.length == 9) {
          var url = "https://suggestions.dadata.ru/suggestions/api/4_1/rs/findById/bank";
          var token = "04b7cf5657185c9a3d363fc6680a7fe198a65cb8";
          var query = this.bik;
          let config = {
            mode: "cors",
            headers: {
              "Content-Type": "application/json",
              "Accept": "application/json",
              "Authorization": "Token " + token
            },
          };

          this.$http.post(url, JSON.stringify({query: query}), config)
                  .then(({data}) => {
            this.bank = data.suggestions[0].value;
            this.bank_address = data.suggestions[0].data.address.value;
            this.correspondent_account = data.suggestions[0].data.correspondent_account;
          }).catch((error) => {
              console.log(error);
          });
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.top{
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 10px;
  &__title{
    display: flex;
    flex-wrap: wrap;
    .name{
      display: flex;
      align-items: center;
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 19px;
      color: #2D3137;
      margin-right: 30px;
    }
    .status{
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 14px;
      color: #2CB181;
    }
    &-radio{
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 16px;
      display: flex;
      width: max-content;
      background-color: white;
      border-radius: 4px;
      border: 1px solid #EEF0F3;

      &-item {
        cursor: pointer;
        padding: 10px 15px;
        margin: 2px;
        color: #7A818F;
      }
      &-item.active {
        color: #2D3137;
        background: #EEF0F3;
        border-radius: 4px;
      }
    }
  }
}
.btn{
  width: 100%;
  padding: 0;
  margin-top: 15px;
button{
  width: 100%;
  height: 50px;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #FFFFFF;
  background: #2CB181;
  border-radius: 4px;
  border: none;
}
}
.modal-form {
  padding: 20px;
}

.input-block {
  margin-bottom: 15px;
}
h4{
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  color: #000000;
  margin: 0 0 5px 1px;
  &.add{
    display: flex;
    justify-content: space-between;
    a{
      font-family: Roboto;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 16px;
      text-align: right;
      text-decoration-line: underline;
      color: #7A818F;
    }
  }
}
button:disabled{
  background-color: #7A818F;
}
input{
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  color: #7A818F;
  padding-left: 10px;
  width: 100%;
  height: 40px;
  background: #FFFFFF;
  border: 1px solid #EEF0F3;
  box-sizing: border-box;
  border-radius: 4px;
  &.about{
    height: 117px;
  }
  &:disabled{
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 14px;
    color: #7A818F;
    background: #EEF0F3;
  }
}
.checkbox {
  display: flex;
  align-items: center;
  position: relative;
  padding-left: 35px;
  margin: 10px 0 12px 0;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  color: #7A818F;
}
.checkbox input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}
.checkmark {
  position: absolute;
  left: 0;
  height: 20px;
  width: 20px;
  background-color: #eee;
  box-shadow: 0px 0px 3px #E5E5EA;
  border-radius: 4px;
}
.checkbox:hover input ~ .checkmark {
  background-color: #ccc;
}
.checkbox input:checked ~ .checkmark {
  background-color: #ccc;
}
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}
.checkbox input:checked ~ .checkmark:after {
  display: block;
}
.checkbox .checkmark:after {
  left: 8px;
  top: 4px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
button{
  &.big{
    height: 50px;
  }
  &:disabled{
    &:hover{
      background: #B6BCC8;
    }
  }

  &.outlined{
    &:hover{
      color: #2CB181;
      border-color: #2CB181;
      background: transparent;
    }
  }
  &:hover{
    background: #25966E;
  }
}
</style>
